// Globals
import { FC } from 'react';

// Modules
import { CreateFaqModal, TFaqFormValues } from '@/modules/FaqCommon';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { createFaq, selectFaqsIsLoading } from '../feature';

type TCreateChannelFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  channelId: number;
};

const CreateChannelFaqModal: FC<TCreateChannelFaqModalProps> = ({ isOpen, onClose, channelId }) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectFaqsIsLoading);

  const handleCreateFaq = async (values: TFaqFormValues) => {
    try {
      await dispatch(createFaq({ ...values, channelId })).unwrap();
      onClose();
    } catch {}
  };

  return <CreateFaqModal isOpen={isOpen} onClose={onClose} onSubmit={handleCreateFaq} isLoading={isLoading} />;
};

export default CreateChannelFaqModal;
